import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from 'app/shared/components/toast-container/toast-container.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet, ToastContainerComponent],
})
export class AppComponent {
    /**
     * Constructor
     */
    constructor() {}
}
